// Combina changelog.js (contenido) + changelogNoveltyLogic.js (vigencia por
// fecha) + changelogSeenStorage.js (visto/no visto en localStorage) en una
// sola consulta: "de estos anchors, ¿hay alguna novedad que todavía valga
// la pena mostrar?". La usan tanto el punto decorativo del tab como el
// botón interactivo de info, para que ambos vean siempre el mismo estado.
import { getEntriesForAnchor } from "../../../data/changelog";
import {
  isWithinNoveltyWindow,
  entradaMasReciente,
  DEFAULT_NOVELTY_WINDOW_DAYS,
} from "../../../services/changelogNoveltyLogic";
import { isSeen } from "../../../services/changelogSeenStorage";

export function resolveNoveltyEntry(anchors, days = DEFAULT_NOVELTY_WINDOW_DAYS) {
  const todas = (anchors || []).flatMap((anchor) => getEntriesForAnchor(anchor));
  const vigentes = todas.filter((entry) => isWithinNoveltyWindow(entry, days) && !isSeen(entry.id));
  return entradaMasReciente(vigentes);
}
